export class DeleteClusterComuniINModel { 
    idClusterComuni: number
}